import React from 'react';
import { useForm, SubmitHandler, UseFormReturn, FieldValues, DefaultValues } from 'react-hook-form'; // Importer DefaultValues

interface FormWrapperProps<TFormValues extends FieldValues> {
  onSubmit: SubmitHandler<TFormValues>;
  children: (methods: UseFormReturn<TFormValues>) => React.ReactNode;
  className?: string;
  id?: string;
  defaultValues?: DefaultValues<TFormValues>; // Utiliser le type DefaultValues
}

const FormWrapper = <TFormValues extends FieldValues>({
  onSubmit,
  children,
  className,
  id,
  defaultValues, // Destructurer la nouvelle prop
}: FormWrapperProps<TFormValues>) => {
  // Passer defaultValues à useForm
  const methods = useForm<TFormValues>({ defaultValues });
  const { handleSubmit } = methods;

  return (
    <form id={id} className={className} onSubmit={handleSubmit(onSubmit)}>
      {children(methods)}
    </form>
  );
};

export default FormWrapper;
